import BaseService from "../BaseService";
import _ from "lodash";

class CartService extends BaseService {

    get = async (id) => {
        var data = await this._api.get(`/store/order/get`, { params: { id } });
        return data;
    };
    paymentProof = async ({ id, image }) => {
        var data = await this._api.post(`/store/order/payment_proof`, { id, image });
        return data;
    };

    paymentCOD = async ({ id }) => {
        var data = await this._api.post(`/store/order/payment_cod`, { id });
        return data;
    };



    list = async (filter) => {
        var data = await this._api.post(`/store/order/list`, filter);
        return data;
    };




    createInvoiceFile = async ({ id }) => {
        var data = await this._api.post(`/store/order/create_invoice_file`, { id });
        return data;
    }

    
    cancel = async ({ id }) => {
        var data = await this._api.post(`/store/order/cancel`, { id });
        return data;
    }





}
export default CartService;
